import { CConditionalTeleport } from './CConditionalTeleport.js';

const CConditionalTeleportPlugin = {
    install: (app) => {
        app.component(CConditionalTeleport.name, CConditionalTeleport);
    },
};

export { CConditionalTeleport, CConditionalTeleportPlugin };
//# sourceMappingURL=index.js.map
